import { StaffSalary } from "@/actions/ssr/staff-management/getStaffSalarySSR";
import { createSlice } from "@reduxjs/toolkit";

export interface StaffSalaryState {
  staffSalary: StaffSalary[];
  staffSalaryLoading: boolean;
  selectedStaffSalary: StaffSalary | null;

  // Backend pagination info
  staffSalaryPagination: {
    count: number;
    next: string | null;
    previous: string | null;
  };

  // Staff members for account dropdown (simplified)
  staffAccounts: Array<{
    value: string;
    label: string;
  }>;

  //create or edit dialog state
  staffSalaryCreateEditDialogOpen: {
    open: boolean;
    openFor: "create" | "edit" | "view";
    editItemData?: Partial<StaffSalary>;
  };

  staffSalaryCreateEditLoading: boolean;
  staffSalaryCreateEditError: string | null;
  staffSalaryDeleteLoading?: {
    loading: boolean;
    deleteItemId?: number;
  };

  isStaffSalaryDialogOpen: {
    open: boolean;
    deleteItemId: number | undefined;
  };
}

const initialState: StaffSalaryState = {
  // Staff salary from API
  staffSalary: [],
  staffSalaryLoading: false,
  selectedStaffSalary: null,

  // Backend pagination info
  staffSalaryPagination: {
    count: 0,
    next: null,
    previous: null,
  },

  // Staff members for account dropdown (simplified)
  staffAccounts: [],

  //create or edit dialog state
  staffSalaryCreateEditDialogOpen: {
    open: false,
    openFor: "create",
    editItemData: undefined,
  },

  staffSalaryCreateEditLoading: false,
  staffSalaryCreateEditError: null,
  staffSalaryDeleteLoading: {
    loading: false,
    deleteItemId: undefined,
  },

  isStaffSalaryDialogOpen: {
    open: false,
    deleteItemId: undefined,
  },
};

export const staffSalarySlice = createSlice({
  name: "staffSalary",
  initialState,
  reducers: {
    setStaffSalary: (state, action) => {
      state.staffSalary = action.payload;
    },
    setStaffSalaryLoading: (state, action) => {
      state.staffSalaryLoading = action.payload;
    },
    setStaffSalaryPagination: (state, action) => {
      state.staffSalaryPagination = action.payload;
    },

    setStaffAccounts: (state, action) => {
      state.staffAccounts = action.payload;
    },

    //create or edit dialog state
    setStaffSalaryCreateEditDialogOpen: (state, action) => {
      state.staffSalaryCreateEditDialogOpen = action.payload;
    },

    clearStaffSalaryCreateEditDialogOpen: (state) => {
      state.staffSalaryCreateEditDialogOpen = {
        open: false,
        openFor: "create",
        editItemData: undefined,
      };
    },

    setStaffSalaryCreateEditLoading: (state, action) => {
      state.staffSalaryCreateEditLoading = action.payload;
    },

    setStaffSalaryCreateEditError: (state, action) => {
      state.staffSalaryCreateEditError = action.payload;
    },

    setStaffSalaryDeleteLoading: (state, action) => {
      state.staffSalaryDeleteLoading = action.payload;
    },

    setIsStaffSalaryDialogOpen: (state, action) => {
      state.isStaffSalaryDialogOpen = action.payload;
    },

    setSelectedStaffSalary: (state, action) => {
      state.selectedStaffSalary = action.payload;
    },
  },
});

export const {
  setStaffSalary,
  setStaffSalaryLoading,
  setStaffSalaryPagination,
  setStaffAccounts,
  setStaffSalaryCreateEditDialogOpen,
  clearStaffSalaryCreateEditDialogOpen,
  setStaffSalaryCreateEditLoading,
  setStaffSalaryCreateEditError,
  setStaffSalaryDeleteLoading,
  setIsStaffSalaryDialogOpen,
  setSelectedStaffSalary,
} = staffSalarySlice.actions;

export default staffSalarySlice.reducer;
